export default "__VITE_ASSET__8b0b2a76__"